import type { Point } from '../SurfaceBase';

export function radiansToDegrees(radians: number) {
  return (radians * 180) / Math.PI;
}

// return radians
export function lineAngle(p1: Point, p2: Point) {
  return Math.atan2(p2.y - p1.y, p2.x - p1.x);
}

export function distance(p1: Point, p2: Point) {
  return Math.sqrt((p2.x - p1.x) ** 2 + (p2.y - p1.y) ** 2);
}

export function polygonCentroid(vertices: Point[]) {
  let a = 0,
    x = 0,
    y = 0,
    l = vertices.length;

  for (let i = 0; i < l; i++) {
    const s = i === l - 1 ? 0 : i + 1,
      v0 = vertices[i],
      v1 = vertices[s],
      f = v0.x * v1.y - v1.x * v0.y;

    a += f;
    x += (v0.x + v1.x) * f;
    y += (v0.y + v1.y) * f;
  }

  const d = a * 3;

  return {
    x: x / d,
    y: y / d,
  };
}

export function pointTranslate(
  point: Point,
  angle: number, // in radians
  distance: number,
) {
  return {
    x: point.x + distance * Math.cos(angle),
    y: point.y + distance * Math.sin(angle),
  };
}

export function pointRotate(
  point: Point,
  angle: number, // in radians
  origin: Point,
) {
  const p0 = {
    x: point.x - origin.x,
    y: point.y - origin.y,
  };
  const rotated = {
    x: p0.x * Math.cos(angle) - p0.y * Math.sin(angle),
    y: p0.x * Math.sin(angle) + p0.y * Math.cos(angle),
  };
  return {
    x: rotated.x + origin.x,
    y: rotated.y + origin.y,
  };
}

export function polygonScale(polygon: Point[], scale: number, origin: Point) {
  const p = [];

  for (let i = 0, l = polygon.length; i < l; i++) {
    const v = polygon[i],
      d = distance(origin, v),
      a = lineAngle(origin, v);

    p[i] = pointTranslate(origin, a, d * scale);
  }

  return p;
}

export function polygonRotate(polygon: Point[], angle: number, origin: Point) {
  const p = [];

  for (let i = 0, l = polygon.length; i < l; i++) {
    p[i] = pointRotate(polygon[i], angle, origin);
  }

  return p;
}
